module.exports = __webpack_public_path__ + "img/google-display-and-video-ads.9a581a72.svg";